import { JsonApiProcessor, OperationServiceAdapter } from '../../../data/services'

interface CustomFactoryMethods {[className: string]: (r: JsonApiProcessor) => OperationServiceAdapter<any> }

export class OperationServiceFactory {
  constructor(
    private _jsonApiProcessor: JsonApiProcessor,
    private _customFactoryMethods: CustomFactoryMethods = {}
  ) {}

  public create<T extends OperationServiceAdapter<any>>(klass: {new(...args: any[]): T}): T {
    const strategy = this._customFactoryMethods[klass.name] || ((processor: JsonApiProcessor) => new klass(processor))
    return strategy(this._jsonApiProcessor) as T
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/model-repository/creators/operation-service-factory/operation-service.factory.ts